module.exports = __webpack_public_path__ + "media/application/images/svgs/clock-f578b893179f28476ef3914d70215d93.svg";